import styled from 'styled-components';

export const CreditsModalRightStyle = {
  Form: styled.form``,
};
